/* Warthog mobile-only behaviour tweaks. Runs only on phones (<768px). */
(function () {
  var mq = window.matchMedia('(max-width: 767.98px)');
  if (!mq.matches) return;

  function init() {
    // 1. Long product descriptions: collapse with a Read more toggle.
    document.querySelectorAll('.product__block--description').forEach(function (block) {
      if (block.dataset.mobileCollapsed) return;
      block.dataset.mobileCollapsed = '1';
      if (block.scrollHeight < 900) return; // short enough, leave alone
      block.classList.add('is-collapsible');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mobile-readmore';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Read full description';
      btn.addEventListener('click', function () {
        var open = block.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show less' : 'Read full description';
        if (!open) block.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
      block.insertAdjacentElement('afterend', btn);
    });

    // 2. Product page accordions (e.g. Financing Options) start closed on phones.
    document.querySelectorAll('.product__block--collapsible_tab details[open]').forEach(function (d) {
      d.removeAttribute('open');
      d.setAttribute('aria-expanded', 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
